import { createContext, useContext, useState, useEffect } from "react";

const CountryCodeContext = createContext();

const CACHE_KEY = "countryCode";
const CACHE_TIME_KEY = "countryCodeTimestamp";
const CACHE_DURATION = 24 * 60 * 60 * 1000 * 30; // 30 days

export const CountryCodeProvider = ({ children }) => {
    const [countryCode, setCountryCode] = useState(() => {
        return localStorage.getItem(CACHE_KEY) || 'us'; // Default to 'us'
    });

    useEffect(() => {
        const fetchCountryCode = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                const newCountryCode = data.country_code.toLowerCase();

                setCountryCode(newCountryCode);
                localStorage.setItem(CACHE_KEY, newCountryCode);
                localStorage.setItem(CACHE_TIME_KEY, Date.now()); // Save timestamp
            } catch (error) {
                console.error("Error fetching country code:", error);
            }
        };

        // Check last fetch time
        const lastFetchTime = localStorage.getItem(CACHE_TIME_KEY);
        if (!lastFetchTime || Date.now() - lastFetchTime > CACHE_DURATION) {
            fetchCountryCode(); // Fetch only if cache is expired
        }

    }, []);

    return (
        <CountryCodeContext.Provider value={countryCode}>
            {children}
        </CountryCodeContext.Provider>
    );
};

export const useCountryCode = () => {
    return useContext(CountryCodeContext);
};
